//main
import ContentFormatXX from '../content/webc/content-format-xx';

import WebbDividerSmall from "../content/webb/webb-divider-sm";
import HeaderSectionDark from "../content/webb/head-section-dark";

import TransferCreditModule from '../content/transfers/transfer-credit';

import { UserForm } from "../services/srvc-utilities";

export default function TransfersCredit() {

  return (
  <>
    <ContentFormatXX 
      head='Request Funds'
      link={`/${UserForm()}/home`}
      form= 'mini'
      data= {
        <>
          <WebbDividerSmall />
          <TransferCreditModule />


        </>
      } 
    />
  </>
  )
}